import { get, post } from '@/utils/request'

const TYPE = 'FILE'

// 图片上传
export const upLoadImg = file => post('/image/upload', file, { TYPE })

// 获取省份列表
export const getProvince = params => get('/common/address/province', params)

// 获取城市列表
export const getCity = params => get('/common/address/city', params)

// 获取区县列表
export const getRegion = params => get('/common/address/region', params)

// 获取区县列表
export const region = params => get('/common/address/region', params)

// 查询当前商家的三级分类
export const queryClassify = params => get('/commonData/queryCompanyDirectorys', params)

// 获取标准分类
export const getCates = params => get('/commonData/queryStandardDirectorys', params)

// 查询品牌表数据
export const getBrand = params => get('/commonData/queryBrand', params)

// 查询字典表数据
export const getDirctItem = params => get('/commonData/queryDictItems', params)

// 查询当前商家下子公司列表
export const querySubCompany = params => get('/commonData/querySubCompany', params)

// 查询当前商家或子公司下的所有门店、店铺
export const findPharmacyByParams = params => get('/pharmacy/findPharmacyByParams', params)

export const findCityByPharmacyId = params => get('/pharmacy/findCityByPharmacyId', params)

// 查询生产厂商
export const queryManufacturers = params => get('/commonData/queryManufacturers', params)

// 查询当前商家下门店列表
export const queryPharmacy = params => get('/commonData/queryPharmacy', params)

// 查询生产企业许可证号数据
export const queryManufacturersCard = params => get('/commonData/queryManufacturersCard', params)

// 查询服用禁忌列表
export const queryTabooList = params => get('/commonData/queryTabooList', params)

// 查询标签列表
export const queryTabList = params => get('/commonData/queryTabList', params)

// 查询疾病列表
export const querySymptomList = params => get('/commonData/querySymptomList', params)

// 查询医疗器械类别子项
export const queryTypeItem = params => get('/commonData/queryTypeItem', params)

// 物流商
export const getDeliveryList = params => get('/pickOrder/getDeliveryList', params)

// 生成助记码
export const getMemoryCode = params => get('/commonData/getMemoryCode', params)

// 获取拼团标签
export const activityTabs = () => get('/groupBuyingActivity/queryActivityTabs?pageSize=1000&pageNo=1')

// 查询当前商家的三级分类
export const queryClassifyForSku = params => get('/commonData/queryCompanyDirectorysForSku', params)
